module.exports = __webpack_public_path__ + "img/班鲁生产4.23befe59.png";